import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class LookupApi {

  private service: string = '';
  private model: string = 'lookup';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public country(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'country';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public state(countryId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'state';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof countryId !== 'undefined' && countryId !== null) urlParams.countryId = countryId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public city(stateId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'city';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof stateId !== 'undefined' && stateId !== null) urlParams.stateId = stateId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public district(cityId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'district';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof cityId !== 'undefined' && cityId !== null) urlParams.cityId = cityId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public subdistrict(districtId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'subdistrict';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof districtId !== 'undefined' && districtId !== null) urlParams.districtId = districtId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public statusliving(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'statusliving';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public statusowner(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'statusowner';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public educationLevel(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'educationLevel';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public educationalInstitution(status): Observable<any> {
    console.log('educationalInstitution status', status)
    const method: string = 'GET';
    const func: string = 'educationalInstitution';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof status !== 'undefined' && status !== null) urlParams.status = status;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refFaculty(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refFaculty';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refMajor(status): Observable<any> {
    console.log('refMajor status', status)
    const method: string = 'GET';
    const func: string = 'refMajor';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof status !== 'undefined' && status !== null) urlParams.status = status;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refBloodType(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refBloodType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public familyRelationship(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'familyRelationship';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refClothSize(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refClothSize';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refResignReason(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refResignReason';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refLineOfBusiness(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refLineOfBusiness';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refDisability(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refDisability';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public refCurrency(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'refCurrency';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public allCity(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'allCity';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public allState(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'allState';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public allDistrict(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'allDistrict';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public allSubdistrict(subdistrict): Observable<any> {
    console.log('allSubdistrict', subdistrict)
    const method: string = 'GET';
    const func: string = 'allSubdistrict';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof subdistrict !== 'undefined' && subdistrict !== null) urlParams.subdistrict = subdistrict;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public companyGroup(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'companyGroup';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/lookup.api.ts